import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
  DvRadioGroupComponent,
} from '@devinco/ui/dds';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Language } from '@shared/constants/language';
import { LocalStorageKeys } from '@shared/constants/local-storage-keys';
import { take } from 'rxjs';

@Component({
  selector: 'app-language-dialog',
  imports: [DvDialogContentComponent, DvRadioGroupComponent, TranslatePipe, DvButtonComponent],
  templateUrl: './language-dialog.component.html',
  styleUrl: './language-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageDialogComponent extends DvDialogContent<undefined> {
  protected translate = inject(TranslateService);
  private translationService = inject(TranslationService);

  items = signal<{ label: string; value: string }[]>([
    { label: this.translate.instant('General.English'), value: Language.English },
    { label: this.translate.instant('General.Norwegian'), value: Language.Norwegian },
    { label: this.translate.instant('General.Swedish'), value: Language.Swedish },
  ]).asReadonly();

  value = signal(
    localStorage.getItem(LocalStorageKeys.LastSelectedLanguage) ??
      this.translate.getCurrentLang() ??
      'en',
  );

  onValueChange(event: unknown): void {
    this.value.set(event as Language);
  }

  save(): void {
    const selectedLanguage = this.value();

    if (selectedLanguage && selectedLanguage !== this.translate.getCurrentLang()) {
      this.translationService
        .setTranslation(selectedLanguage as Language)
        .pipe(take(1))
        .subscribe();
      this.onClose();
    }
  }
}
